import { render, staticRenderFns } from "./userregister.vue?vue&type=template&id=f48b90b8&scoped=true&"
import script from "./userregister.vue?vue&type=script&lang=js&"
export * from "./userregister.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f48b90b8",
  null
  
)

export default component.exports